import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "filter-sections" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Choix de la colonne à filtrer")
], -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "filter-sections row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Type de filtre")
], -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "filter-sections row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title-3" }, "Valeur à filtrer")
], -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 5 }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]

import Modal from "@/domains/app/components/Modal.vue";
import { useUser } from "@/domains/auth/user";
import { ABILITY_READ_RESTRICTED_CRUDS } from "@/domains/cruds/users/users";
import { ListItemConfig } from "@/domains/search/list";
import { ref, computed, watch, reactive } from "vue";
import { sheetColumns } from "../config";
import { Filter, FilterType } from "../filters";
import { SheetFilterColumns } from "../statistics";
import SearchResource from "@/domains/search/components/SearchResource.vue";
import {
    ADMINISATRATION_LEVEL_DELEGATE,
    ADMINISATRATION_LEVEL_USER,
    Department,
} from "@/domains/cruds/departments/departments";
import { request } from "@/domains/api/api";
import { Sheet } from "@/domains/cruds/sheets/sheets";
import { getSeasonBound } from "../tools";

type LabelGroup = {
    title: string;
    children: (keyof SheetFilterColumns)[];
};


export default /*#__PURE__*/_defineComponent({
  props: {
    userLevel: null
  },
  emits: ["close", "add-filter"],
  setup(__props: any, { emit }: { emit: ({
    (e: "close"): void;
    (e: "add-filter", filter: Filter): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { userLevel: number }



const step = ref(1);
watch(step, (s) => {
    if (s == 2 && availableOperators.value.length == 1) {
        chosenOperator.value = availableOperators.value[0] as FilterType;
        chosenValue.value = "0";
        confirm();
    }
});

const user = useUser().user;
const delegateDepartmentAdministrationLevel = ref<
    typeof ADMINISATRATION_LEVEL_DELEGATE | typeof ADMINISATRATION_LEVEL_USER
>();
watch(
    user,
    (user) => {
        if (user && user?.department_id > 0) {
            request<Department>(
                "departments/" + user.department_id,
                "get"
            ).then((rs) => {
                if (rs)
                    delegateDepartmentAdministrationLevel.value =
                        rs.administration_level;
            });
        }
    },
    { immediate: true }
);

const chosenColumn = ref<[number, number]>();
const chosenOperator = ref<Filter["type"]>();
const chosenValue = ref<string>();
const chosenValueLabel = ref<string>("");
const chosenValueDate = computed<string | undefined>({
    set: (v) => {
        chosenValue.value = v ? "" + new Date(v).getTime() : undefined;
    },
    get: () =>
        chosenValue.value
            ? new Date(chosenValue.value).toISOString().split("T")[0]
            : undefined,
});
const chosenValueBool = computed<boolean>({
    set: (v) => {
        chosenValue.value = v ? "1" : "0";
    },
    get: () => chosenValue.value === "1",
});
const chosenValueRangeSeason = reactive<[string, string]>(["", ""]);
watch(chosenValueRangeSeason, (v) => {
    chosenValue.value = v.join(";");
});

const chosenLabel = computed<keyof SheetFilterColumns | undefined>(() =>
    chosenColumn.value !== undefined
        ? labelGroups[chosenColumn.value[0]].children[chosenColumn.value[1]]
        : undefined
);

const confirmButtonProp = computed(() => ({
    disabled:
        (step.value === 1 && chosenColumn.value === undefined) ||
        (step.value === 2 && chosenOperator.value === undefined),
}));

const chosenColumnConfig = computed(() => {
    if (!chosenLabel.value) return;
    const config = sheetColumns[chosenLabel.value] as NonNullable<
        SheetFilterColumns[number | string]
    >;
    return config;
});

const availableOperators = computed<FilterType[]>(() => {
    const r: FilterType[] = ["="];
    if (chosenColumnConfig.value) {
        if (["number", "date"].includes(chosenColumnConfig.value.type)) {
            r.push("<", ">");
        } else if (chosenColumnConfig.value.type !== "bool") {
            r.push("≠");
        }
        if (chosenColumnConfig.value.type === "season") {
            r.push("range");
        }
    }
    return r;
});

const chosenColumnId = computed(() => {
    if (!chosenColumn.value) return null;
    return labelGroups[chosenColumn.value[0]].children[chosenColumn.value[1]];
});
const searchResourceHeaderText = computed(() =>
    !chosenColumnId.value || !depOrUserColumns[chosenColumnId.value]
        ? ""
        : props.userLevel >= 2
        ? `Liste de tous les ${
              depOrUserColumns[chosenColumnId.value]
          } au niveau nationnal, y compris ceux qui ne sont pas rattachés à `
        : props.userLevel == 0
        ? `Vous ne pouvez voir que vos ${
              depOrUserColumns[chosenColumnId.value]
          } et non ceux que vous avez pu utiliser en intervenant sur des départements gérés par des délégués`
        : delegateDepartmentAdministrationLevel.value ===
          ADMINISATRATION_LEVEL_DELEGATE
        ? `C'est la liste des ${
              depOrUserColumns[chosenColumnId.value]
          } utilisables par les conducteurs sur votre département`
        : `Cette liste ne contient que vos ${
              depOrUserColumns[chosenColumnId.value]
          }, si vous voulez faire des statistiques sur les ${
              depOrUserColumns[chosenColumnId.value]
          } de votre département, c'est à vous de gérer la liste des ${
              depOrUserColumns[chosenColumnId.value]
          }`
);



function confirm() {
    step.value++;
    if (
        !chosenColumn.value ||
        !chosenOperator.value ||
        chosenValue.value === undefined
    )
        return;
    if (step.value === 4) {
        let visibleValue = "" + chosenValue.value;
        if (chosenColumnConfig.value?.type === "relation") {
            visibleValue = chosenValueLabel.value;
        } else if (
            chosenColumnConfig.value?.type === "season" &&
            chosenOperator.value !== "range"
        ) {
            const d = new Date(chosenValue.value);
            visibleValue = d.getFullYear() + "/" + (d.getFullYear() + 1);
        } else if (
            chosenColumnConfig.value?.type === "season" &&
            chosenOperator.value === "range"
        ) {
            const s1 = getSeasonBound(parseInt(chosenValueRangeSeason[0]));
            const s2 = getSeasonBound(parseInt(chosenValueRangeSeason[1]));
            visibleValue = s1.label + " -> " + s2.label;
        } else if (chosenColumnConfig.value?.type === "date") {
            visibleValue = new Date(chosenValue.value)
                .toLocaleDateString()
                .split(" ")[0];
        } else if (chosenColumnConfig.value?.type === "bool") {
            visibleValue = chosenValueBool.value ? "oui" : "non";
        }

        emit("add-filter", {
            col: labelGroups[chosenColumn.value[0]].children[
                chosenColumn.value[1]
            ],
            type: chosenOperator.value,
            value: chosenValue.value,
            visibleValue,
        });

        emit("close");
    }
}

function cancel() {
    step.value--;
    if (step.value === 0) {
        emit("close");
    }
}

function onRelationChosen(rel: ListItemConfig) {
    if (rel.value === undefined || typeof rel.value !== "number") return;
    chosenValue.value = "" + rel.value;
    chosenValueLabel.value = rel.label;
}

function getSearchQueryParams(level: number) {
    let levelStr: string;
    switch (level) {
        case 2:
            levelStr = "country";
            break;
        case 1:
            levelStr = "department";
            break;
        default:
            levelStr = "user";
            break;
    }
    return () =>
        computed(() => ({
            scope: levelStr,
        }));
}

function getOperatorLabel(col: FilterType): string {
    if (col === "range") return "intervalle";
    return col;
}

const depOrUserColumns: Record<keyof Sheet, string> = {
    gic_id: "GIC",
    requester_id: "demandeurs",
    location_id: "lieux",
};
const labelGroups: LabelGroup[] = [
    {
        title: "Gibier",
        children: ["weight", "game_id", "age", "gender", "injuries"],
    },
    {
        title: "Chien",
        children: ["dog_id"],
    },
    {
        title: "Acte de recherche",
        children: [
            "season_id",
            "date",
            "result_id",
            "failures",
            "path_age",
            "result_id",
            "duration",
            "shot_distance",
            "disturbed",
        ],
    },
    {
        title: "Poursuite",
        children: ["pursuit_id", "pursuit_length", "leash_length", "pace_id"],
    },
    {
        title: "Chasseur",
        children: [
            "shot_id",
            "aim_id",
            "requester_id",
            "weapon_id",
            "position_id",
            "calibre_id",
            "ammunition_id",
        ],
    },
    {
        title: "Chasse",
        children: ["hunt_id", "hunt_type_id"],
    },
    {
        title: "Localisation",
        children: ["department_id", "location_id", "gic_id"],
    },
    {
        title: "Autre",
        children: ["vehicule_km", "weather_id", "paid_trip"],
    },
];

if (
    user.value?.abilities?.includes(ABILITY_READ_RESTRICTED_CRUDS) &&
    props.userLevel > 0
) {
    const g = labelGroups.find((g) => g.title === "Acte de recherche");
    if (g) {
        g.children.unshift("user_id");
    }
}

const seasons: { label: string; start: number; end: number }[] = [];
const start = new Date("2009-04-01T00:00:00.000Z");

const now = new Date().getTime();
while (start.getTime() < now) {
    seasons.push(getSeasonBound(start.getTime()));
    start.setUTCFullYear(start.getUTCFullYear() + 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (step.value === 1)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          onConfirm: confirm,
          onCancel: cancel,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
          confirm: _unref(confirmButtonProp)
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_1, [
              _hoisted_2,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(labelGroups, (labelGroup, index) => {
                return _createElementVNode("article", {
                  class: "item",
                  key: labelGroup.title
                }, [
                  _createElementVNode("header", null, [
                    _createElementVNode("h3", null, _toDisplayString(labelGroup.title), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labelGroup.children, (child, index2) => {
                    return (_openBlock(), _createElementBlock("button", {
                      class: _normalizeClass(["btn", {
                        selected:
                            chosenColumn.value &&
                            index === chosenColumn.value[0] &&
                            index2 === chosenColumn.value[1],
                    }]),
                      onClick: ($event: any) => (chosenColumn.value = [index, index2]),
                      key: child
                    }, _toDisplayString(_unref(sheetColumns)[child]?.trad), 11, _hoisted_3))
                  }), 128))
                ])
              }), 64))
            ])
          ]),
          _: 1
        }, 8, ["confirm"]))
      : _createCommentVNode("", true),
    (step.value === 2)
      ? (_openBlock(), _createBlock(Modal, {
          key: 1,
          onConfirm: confirm,
          onCancel: cancel,
          onExit: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
          confirm: _unref(confirmButtonProp)
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableOperators), (operator) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["btn item", { selected: chosenOperator.value === operator }]),
                  key: operator,
                  onClick: ($event: any) => (chosenOperator.value = operator)
                }, _toDisplayString(getOperatorLabel(operator)), 11, _hoisted_6))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["confirm"]))
      : _createCommentVNode("", true),
    (step.value === 3 && chosenColumn.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 2,
          onConfirm: confirm,
          onCancel: cancel,
          onExit: _cache[10] || (_cache[10] = ($event: any) => (emit('close'))),
          confirm: _unref(confirmButtonProp)
        }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_7, [
              _hoisted_8,
              (_unref(chosenColumnConfig)?.type === 'number')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: "number",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((chosenValue).value = $event))
                  }, null, 512)), [
                    [_vModelText, chosenValue.value]
                  ])
                : (_unref(chosenColumnConfig)?.type === 'date')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "date",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(chosenValueDate) ? (chosenValueDate).value = $event : null))
                    }, null, 512)), [
                      [_vModelText, _unref(chosenValueDate)]
                    ])
                  : (_unref(chosenColumnConfig)?.type === 'bool')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 2,
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(chosenValueBool) ? (chosenValueBool).value = $event : null))
                      }, null, 512)), [
                        [_vModelCheckbox, _unref(chosenValueBool)]
                      ])
                    : (_unref(chosenColumnConfig)?.type === 'choice')
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 3,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((chosenValue).value = $event))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chosenColumnConfig).choices, (value, trad) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: value,
                              value: value
                            }, _toDisplayString(trad), 9, _hoisted_9))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, chosenValue.value]
                        ])
                      : (
                    _unref(chosenColumnConfig)?.type === 'season' &&
                    chosenOperator.value !== 'range'
                )
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 4,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenValue).value = $event))
                          }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(seasons, (season) => {
                              return _createElementVNode("option", {
                                value: season.start,
                                key: season.start
                              }, _toDisplayString(season.label), 9, _hoisted_10)
                            }), 64))
                          ], 512)), [
                            [_vModelSelect, chosenValue.value]
                          ])
                        : (
                    _unref(chosenColumnConfig)?.type === 'season' &&
                    chosenOperator.value === 'range'
                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(chosenValueRangeSeason)[0]) = $event))
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(seasons, (season) => {
                                  return _createElementVNode("option", {
                                    value: season.start,
                                    key: season.start
                                  }, _toDisplayString(season.label), 9, _hoisted_12)
                                }), 64))
                              ], 512), [
                                [_vModelSelect, _unref(chosenValueRangeSeason)[0]]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(chosenValueRangeSeason)[1]) = $event))
                              }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(seasons, (season) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: season.start
                                  }, [
                                    (
                                !_unref(chosenValueRangeSeason)[0] ||
                                parseInt(_unref(chosenValueRangeSeason)[0]) <
                                    season.start
                            )
                                      ? (_openBlock(), _createElementBlock("option", {
                                          key: 0,
                                          value: season.end
                                        }, _toDisplayString(season.label), 9, _hoisted_13))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 64))
                              ], 512), [
                                [_vModelSelect, _unref(chosenValueRangeSeason)[1]]
                              ])
                            ]))
                          : (_openBlock(), _createBlock(SearchResource, {
                              key: 6,
                              relation: 
                    labelGroups[chosenColumn.value[0]].children[chosenColumn.value[1]]
                ,
                              "onItem:clicked": _cache[9] || (_cache[9] = ($event: any) => (onRelationChosen($event))),
                              "get-search-params": getSearchQueryParams(__props.userLevel),
                              "header-text": _unref(searchResourceHeaderText)
                            }, null, 8, ["relation", "get-search-params", "header-text"]))
            ])
          ]),
          _: 1
        }, 8, ["confirm"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})